import React from "react";
import { useTranslate } from "@tolgee/react";
import { ReactComponent as SmallChat } from "../../Assets/icons/small-chats-icons.svg";
import { ReactComponent as InfoIcon } from "../../Assets/icons/infoIcon.svg";
import { ReactComponent as QuestionIcon } from "../../Assets/iconsv2/generic/Question.svg";
import FormField from "../GenericComponents/FormField";
import Badge from "../GenericComponents/Badge";
import LanguageBtn from "./LanguageBtn";
import BirthdayMenu from "./BirthdayMenu";
import { GENDER_OPTIONS } from "../../Constants/constantValues";
import {
  Fields, LangBtnWrap, TextInput, TextArea, DateInputBox,
  GenderRow, GenderCard, GenderEmoji, GenderLabel, ContinueBtn, InfoBtn,
} from "./shared/OnboardingStyles";

const UserProfileForm = ({
  name, setName,
  language, setLanguage, translationsLanguages,
  birthday, setBirthday,
  gender, setGender,
  culturalBg, setCulturalBg,
  onInfoClick,
  onDetailsInfoClick,
  canContinue, onContinue,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <Fields>
        <FormField label={t("authentication.onboarding.name_label")} badge={<Badge variant="required">{t("general.required")}</Badge>}>
          <TextInput
            placeholder={t("authentication.onboarding.name_placeholder")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
          />
        </FormField>

        <FormField
          label={t("authentication.onboarding.language_label")}
          badge={<Badge variant="required">{t("general.required")}</Badge>}
          hint={t("authentication.onboarding.language_hint")}
        >
          <LangBtnWrap>
            <LanguageBtn
              value={language}
              setValue={setLanguage}
              valuesList={translationsLanguages}
              placeholder={t("register.chat_language_placeholder")}
              placeholderIcon={<SmallChat />}
            />
          </LangBtnWrap>
        </FormField>

        <FormField label={t("authentication.onboarding.birthdate_label")} badge={<Badge variant="recommended">{t("general.recommended")}</Badge>} infoButton={<InfoBtn onClick={onDetailsInfoClick}><QuestionIcon width={16} height={16} /></InfoBtn>}>
          <DateInputBox>
            <BirthdayMenu
              slim={true}
              format={"yyyy-dd-MM"}
              value={birthday}
              noCalendar
              setValue={setBirthday}
              transparent
            />
          </DateInputBox>
        </FormField>

        <FormField label={t("profile.gender")} badge={<Badge variant="recommended">{t("general.recommended")}</Badge>} infoButton={<InfoBtn onClick={onDetailsInfoClick}><QuestionIcon width={16} height={16} /></InfoBtn>}>
          <GenderRow>
            {GENDER_OPTIONS.map((opt) => (
              <GenderCard
                key={opt.value}
                $selected={gender === opt.value}
                onClick={() => setGender(gender === opt.value ? null : opt.value)}
              >
                <GenderEmoji>{opt.emoji}</GenderEmoji>
                <GenderLabel $selected={gender === opt.value}>{t(opt.key)}</GenderLabel>
              </GenderCard>
            ))}
          </GenderRow>
        </FormField>

        <FormField
          label={t("profile.cultural_background")}
          badge={<Badge variant="recommended">{t("general.recommended")}</Badge>}
          infoButton={<InfoBtn onClick={onInfoClick}><InfoIcon width={16} height={16} /></InfoBtn>}
        >
          <TextArea
            placeholder={t("authentication.onboarding.cultural_bg_placeholder")}
            value={culturalBg}
            onChange={(e) => setCulturalBg(e.target.value)}
            maxLength={1000}
          />
        </FormField>
      </Fields>

      <ContinueBtn disabled={!canContinue} onClick={onContinue}>
        {t("general.continue")}
      </ContinueBtn>
    </>
  );
};

export default UserProfileForm;
